var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.078C16.4039 32.078 16.9932 31.7706 17.4785 31.4707C26.3223 25.7682 32 19.0856 32 12.3178C32 6.49093 27.977 2.44824 22.9291 2.44824C19.7861 2.44824 17.4244 4.18462 16 6.78683C14.6017 4.19761 12.2111 2.44824 9.07094 2.44824C4.02304 2.44824 0 6.49093 0 12.3178C0 19.0856 5.6777 25.7682 14.5345 31.4707C15.0068 31.7706 15.5933 32.078 16 32.078Z",
    fill: "#6CD5CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.ba0536e518abacd5c9cc972abf063006.svg";
export { ForwardRef as ReactComponent };